import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import { useAuth } from '../../hooks/useAuth';
import { useFriendRequests } from '../../hooks/useFriendRequests';
import { ROUTES, BADGES } from '../../utils/constants';
import toast from 'react-hot-toast';
import './ProfileDropdown.css';

export default function ProfileDropdown() {
  const { userProfile } = useAuthContext();
  const { logout } = useAuth();
  const { requests } = useFriendRequests();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();

  // Close on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  // Close on click outside
  useEffect(() => {
    if (!isOpen) return;
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  // Close on Escape
  useEffect(() => {
    if (!isOpen) return;
    function handleEsc(e) {
      if (e.key === 'Escape') setIsOpen(false);
    }
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen]);

  const handleLogout = async () => {
    setIsOpen(false);
    await logout();
    toast.success('Signed out');
  };

  if (!userProfile) return null;

  const isProfileActive = location.pathname.startsWith('/profile');

  return (
    <div className="profile-dropdown-wrapper" ref={dropdownRef}>
      <button
        className={`header-profile ${isProfileActive ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="profile-badge">
          {BADGES[userProfile.activeBadge]?.emoji || '🐣'}
        </span>
        <span className="profile-streak">
          🔥 {userProfile.currentStreak || 0}
        </span>
        <span className="profile-username">
          {userProfile.username}
        </span>
        <span className="dropdown-chevron">{isOpen ? '▲' : '▼'}</span>
      </button>

      {isOpen && (
        <div className="profile-dropdown-menu">
          <Link to={ROUTES.PROFILE_SETTINGS} className="dropdown-item">
            Profile
          </Link>
          <Link to={ROUTES.PROFILE_FRIENDS} className="dropdown-item">
            Friends
            {requests.length > 0 && (
              <span className="dropdown-badge">{requests.length}</span>
            )}
          </Link>
          <Link to={ROUTES.PROFILE_STATS} className="dropdown-item">
            Stats
          </Link>
          <Link to={ROUTES.PROFILE_BOUT_HISTORY} className="dropdown-item">
            Bout History
          </Link>
          <div className="dropdown-divider" />
          <button className="dropdown-item dropdown-signout" onClick={handleLogout}>
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
}
